import { NgModule } from '@angular/core';
import { MainLayoutModule } from './main-layout/main-layout.module';
import { AuthModule } from '../auth/auth.module';
@NgModule({
    imports: [
        MainLayoutModule,
        AuthModule
    ],
    exports: [
        MainLayoutModule
    ]
})
export class LayoutModule
{
}
 